// pages/TakeATour.jsx
import clinic1 from '../Assets/TeamandOthers/Interiorimg.webp'
import clinic2 from '../Assets/TeamandOthers/clinic1.webp'
import clinic3 from '../Assets/TeamandOthers/clinic3.webp'
export default function TakeATour() {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-6 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            Take A Tour of Our Clinic
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Experience the modern, hygienic, and patient-friendly environment we’ve created for you in Vijayawada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {/* Images from search results - modern clinic views */}
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src={clinic1}
              alt="Modern dental treatment room"
              className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
            />
            <div className="p-5 bg-white">
              <h3 className="font-semibold text-gray-900">Advanced Treatment Room</h3>
              <p className="text-sm text-gray-600 mt-1">State-of-the-art equipment for painless procedures</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src={clinic2}
              alt="Welcoming reception area"
              className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
            />
            <div className="p-5 bg-white">
              <h3 className="font-semibold text-gray-900">Comfortable Reception</h3>
              <p className="text-sm text-gray-600 mt-1">Spacious waiting area with soothing ambiance</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-lg">
            <img
              src={clinic3}
              alt="High-tech dental setup"
              className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
            />
            <div className="p-5 bg-white">
              <h3 className="font-semibold text-gray-900">Digital Imaging & Diagnostics</h3>
              <p className="text-sm text-gray-600 mt-1">Latest X-ray and intraoral scanning technology</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-16">
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            We maintain strict sterilization protocols and follow international hygiene standards for your safety.
          </p>
          <a
            href="/contact"
            className="inline-block bg-blue-600 text-white px-12 py-5 rounded-full font-medium hover:bg-blue-700 transition shadow-xl text-lg"
          >
            Schedule Your Visit Today
          </a>
        </div>
      </div>
    </div>
  );
}